import { Component, OnInit, ViewChild } from '@angular/core';
import { GrupoService } from './services/grupo.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [GrupoService]
})
export class AppComponent {
	public title = 'declaraciones';
	public identity; 
	public token;

	constructor(
      	private _grupoService: GrupoService
	) { 
		this.identity = this._grupoService.getIdentity(); 
  		this.token = this._grupoService.getToken();
	}

	ngOnInit() {

	}
}
